<template>
    <CompassAlert
        :type="CompassEnums.AlertType.NEUTRAL"
        :description="$t.__('document.DocFormLayout.alert_compliance')"
        :showClose="false"
        :size="size"
        :action="{
            label: $t.__('common.labels.learn_more'),
            callback: openComplianceFaq,
        }"
        :actionPosition="actionPosition"
    />
</template>

<script setup lang="ts">
import { CompassEnums } from '@sellsy/compass2';

interface Props {
    size?: CompassEnums.AlertSize;
    actionPosition?: CompassEnums.AlertActionPosition;
}

withDefaults(defineProps<Props>(), {
    size: CompassEnums.AlertSize.MEDIUM,
    actionPosition: CompassEnums.AlertActionPosition.BOTTOM,
});

const openComplianceFaq = (): void => {
    const url =
        'https://help.sellsy.com/fr/articles/14756178-les-informations-obligatoires-d-une-facture';
    window.open(url, '_blank');
};
</script>
